import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PgCardComponent } from './pg-card.component';
import { PgExpandableCardComponent } from './pg-expandable-card/pg-expandable-card.component';
import { PgExpandableFormCardComponent } from './pg-expandable-form-card/pg-expandable-form-card.component';
import { PgReapplyCardComponent } from './pg-reapply-card/pg-reapply-card.component';
import { PgReapplyCardDirectiveModule } from './pg-reapply-card/pg-reapply-card-directives';

@NgModule({
  imports: [CommonModule, PgReapplyCardDirectiveModule],
  declarations: [
    PgCardComponent,
    PgExpandableCardComponent,
    PgExpandableFormCardComponent,
    PgReapplyCardComponent,
  ],
  exports: [
    PgCardComponent,
    PgExpandableCardComponent,
    PgExpandableFormCardComponent,
    PgReapplyCardComponent,
    PgReapplyCardDirectiveModule,
  ],
})
export class PgCardModule {}
